var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.eqDivClass },
    [
      _c("cargo-ag-grid", {
        staticStyle: { width: "100%", height: "200px", "margin-bottom": "5px" },
        attrs: {
          "grid-options": _vm.gridOptions,
          "column-defs": _vm.finalColumnDefs,
          "show-side-bar": false,
          "row-data": _vm.rowData,
          "auto-fit-content": false
        },
        on: {
          gridReady: function(params) {
            _vm.gridApi = params.api
          }
        }
      }),
      _c(
        "div",
        { staticStyle: { "text-align": "right", "margin-bottom": "5px" } },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.add } },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Add")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "danger" }, on: { click: _vm.remove } },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }